<template>
  <div>
    <div class="history tradeHis" >
      <div class="d-flex align-items-center justify-content-between" >
        <h1>Trading History</h1>
        <div class="action">
            <a @click="toggleTradeHistory"><i class="fa fa-times"></i></a>
        </div>
          <!-- <button class="btn btn-sm btn-outline-light" @click="toggleTradeHistory">
            <i class="fas fa-times"></i>
          </button> -->
      </div>
      <b-tabs  v-if="cusipId">
        <b-tab title="MSRB Trades" active>
          <div class="table-responsive table-wrapper p-0">
            <table class="table table-striped table-hover w-100" >
              <thead>
                <tr>
                  <th scope="col" class=" text-center">QTY</th>
                  <th scope="col" class=" text-center">TRADE DATE</th>
                  <th scope="col" class=" text-center">ID Trade</th>
                  <th scope="col" class=" text-center">Customer Sold</th>
                  <th scope="col" class=" text-center">Customer Bot</th>
                  <th scope="col" class=" text-center">YIELD</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="msrbList.length == 0 && !loading">
                  <td><p class="nodata text-white">No data available</p></td>
                </tr>
                <tr v-for="data in msrbList" :key="data.id">
                  <td class="text-center">{{ data.quantity }}</td>
                  <td class="text-center">
                    {{
                      data.tradeDate
                        ? moment(data.tradeDate).format('MM/DD/YYYY')
                        : 'N/A'
                    }}
                  </td>
                  <td class="text-center">
                    <span v-if="data.idcPrice">{{
                      data.idcPrice | currency
                    }}</span>
                  </td>
                  <td class="text-center">
                    <span v-if="data.soldPrice">{{
                      data.soldPrice | currency
                    }}</span>
                  </td>
                  <td class="text-center">
                    <span v-if="data.botPrice">{{
                      data.botPrice | currency
                    }}</span>
                  </td>
                  <td class="text-center">{{ data.yield }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-tab>
        <!-- My Bids -->
        <b-tab title="My Bids/Buys">
          <div class="table-responsive p-0">
            <table class="table table-striped table-hover w-100">
              <thead>
                <tr>
                  <th scope="col">Date</th>
                  <th scope="col" class="text-center">QTY</th>
                  <th scope="col" class="text-right">Price</th>
                  <th scope="col" class="text-center">Type</th>
                  <th scope="col">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="tradeHistoryMyBids.length == 0 && !loading">
                  <td><p class="nodata text-white">No data available</p></td>
                </tr>
                <tr v-for="bid in tradeHistoryMyBids" :key="bid.id">
                  <th scope="row">{{
                    bid.createdAt
                      ? moment(bid.createdAt).format('MM/DD/YYYY')
                      : 'N/A'
                  }}</th>
                  <td class="text-center">{{ bid.quantity }}</td>
                  <td class="text-right">
                    <span v-if="bid.price">{{ bid.price | currency }}</span>
                  </td>
                  <td class="text-center">{{ bid.bidType }}</td>
                  <td :class="{'text-success': bid.status === 'FILLED', 'text-danger': bid.status === 'REJECTED', 'text-primary': bid.status === 'PENDING'}">{{ bid.status  }}</td>
                </tr>
               
              </tbody>
            </table>
          </div>
        </b-tab>

        <!-- My Trades -->
        <b-tab title="My Trades">
          <div class="table-responsive p-0">
            <table class="table table-striped table-hover w-100">
              <thead>
                <tr>
                  <th scope="col">Trade Date</th>
                  <th scope="col" class="text-center">Type</th>
                  <th scope="col" class="text-center">Qty</th>
                  <th scope="col">Price</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="tradeHistoryMyTrades.length == 0 && !loading">
                  <td><p class="nodata text-white">No data available</p></td>
                </tr>
                <tr v-for="trade in tradeHistoryMyTrades" :key="trade.id">
                  <th scope="row">{{
                    trade.createdAt
                      ? moment(trade.createdAt).format('MM/DD/YYYY')
                      : 'N/A'
                  }}</th>
                  <td class="text-center">{{ trade.bidType == 'BUY' ? 'LIFTED' : trade.bidType  }}</td>
                  <td class="text-center">{{ trade.quantity }}</td>
                  <td>
                    <span v-if="trade.price">{{ trade.price | currency }}</span>
                  </td>
                  
                </tr>
                
               
              </tbody>
            </table>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
import config from '@/config'
import authService from '@/authService'
export default {
  name: 'TradingHistory',
  props :["cusipId" ,"selectedClient"],
  watch: { 
    cusipId: function() { // watch it
          this.getMsrbList();
          this.getMyBids();
        }
    },
  data () {
    return {
       sortColumn: "id",
        sortOrder: "DESC",
        currentPage: 1,
        perPage: 30,
        loading: false,
        totalRows: 0,
        msrbList: [],
        bids: [],
        search: '',
        status: '',
        tradeHistoryMyBids: [],
        tradeHistoryMyTrades: []

        
    }
  },
  methods: {
    toggleTradeHistory() {
      this.$emit('closeTradeHistory');
    },
    getMsrbList () {
      this.loading = true
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      let congnitoSub = this.selectedClient ? this.selectedClient.cognitoSub : authService.getUser().cognitoSub;
      this.$http
        .get(
          config.baseUrlAutoBidder +
            '/autobidder/msrb-trades?page=' +
            this.currentPage +
            '&size=' +
            this.perPage +
            '&search=' +
            this.cusipId +
            '&sortColumn=' +
            this.sortColumn +
            '&sortOrder=' +
            this.sortOrder +
            '&cognitoSub=' +
            congnitoSub +
            '&isForClient=true',
          auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements
          this.msrbList = result.data.content
          this.loading = false
        })
        .catch(() => (this.loading = false))
    },
    getMyBids () {
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }

      this.$http
        .get(
          config.baseUrlAutoBidder +
            '/offering-feed/client-bid-listall?page=' +
            this.currentPage +
            '&size=' +
            this.perPage +
            '&search=' +
            this.search +
            '&sortColumn=' +
            this.sortColumn +
            '&sortOrder=' +
            this.sortOrder +
            '&statuses=' +
            this.status +
            '&bidTypes=' +
            '&processTypes=' +
            '&cusip=' +
            this.cusipId +
            '&userId=' +
            (this.selectedClient ? this.selectedClient.id : authService.getUser().id),

          auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements
          this.tradeHistoryMyBids = result.data.content
          this.tradeHistoryMyTrades = result.data.content.filter(bid => bid.status === 'FILLED');
          this.loading = false
        })
        .catch(() => (this.loading = false))
    },
  },
  mounted () {
    // this.getMsrbList()
    console.log('TradingHistory mounted' , this.cusipId);
    console.log('TradingHistory mounted' , this.selectedClient);

  }
}
</script>
